import dayjs from "dayjs";

export const formatDate = ({date}) => {
  if (date === null || date === "") return null;
  return dayjs(date).format("DD-MM-YYYY");
};
